// extracted by mini-css-extract-plugin
module.exports = {"section":"ExploreMoreCarousel_section__eBMnU","carousel":"ExploreMoreCarousel_carousel__eWlWl"};